<template>
  <div class="map" ref="map">
  </div>
</template>

<script>
export default {
  props: {
    point: {
      type: Object,
      required: true
    },
    zoom: {
      type: Number,
      default: 15
    }
  },
  data () {
    return {
      map: null,
      marker: null
    }
  },

  async mounted () {
    if (this.$mapsEnabled && this.point.lat && this.point.lng) {
      const maps = await this.$loadMaps()
      this.map = new maps.Map(
        this.$refs.map,
        {
          center: this.point,
          zoom: this.zoom
        }
      )

      this.marker = new maps.Marker({
        position: this.point,
        map: this.map
      })
    }
  }
}
</script>

<style scoped>
.map {
  width: 600px;
  max-width: 100%;
  height: 300px;
}

@media (min-width: 1024px) {
  .map.big {
    width: 750px;
    height: 500px;
  }
}
</style>